import React from 'react'

import { Flex, Header, IconMenuButton, Link, Text } from '@driftt/dds'
import {
  KPICard,
  KPICardStatusIndicatorVariantLiteral,
} from '@driftt/dds.reports'
import { DropdownMenuOptions } from '@driftt/dds/dist/packages/core/src/lib/components/DropdownMenu'

import { SalesRepsMetricCategories } from 'types/salesRepSetup'

import { ENABLE_NOTIFICATIONS_HELP_LINK } from '../constants'
import { getActionMenuOptions } from '../helpers'
import { SalesRepRows } from '../types'
import useCopyEmailToClipboard from '../useCopyEmailsToClipboard.hook'
interface SalesRepKPICardProps {
  status: KPICardStatusIndicatorVariantLiteral
  metric: number
  incompleteSalesRepMetric: SalesRepRows[]
  formatMetric: (metric: number) => string
  title: string
  description: string
  metricIdentifier: SalesRepsMetricCategories
  isLoading: boolean
}

const SalesRepKPICard = ({
  status,
  metric,
  incompleteSalesRepMetric,
  formatMetric,
  title,
  description,
  metricIdentifier,
  isLoading,
}: SalesRepKPICardProps) => {
  const { handleCopyEmailToClipboard } = useCopyEmailToClipboard(
    incompleteSalesRepMetric,
    metricIdentifier
  )
  const noMetrics = !incompleteSalesRepMetric && !metric

  const subtitle =
    metricIdentifier === SalesRepsMetricCategories.NOTIFICATIONS_ENABLED ? (
      <>
        {`${description} `}
        <Link
          href={ENABLE_NOTIFICATIONS_HELP_LINK}
          external
          size="small"
          variant="inline"
        >
          Learn more
        </Link>
      </>
    ) : (
      description
    )

  return (
    <KPICard
      hasNoData={noMetrics}
      statusIndicator={status}
      metric={metric}
      formatMetric={formatMetric}
      isLoading={isLoading}
    >
      <KPICard.Header>
        <Flex direction="column" height={64} gap={0}>
          <Flex fullWidth justifyContent="space-between" alignItems="center">
            <Header variant={'h3'}>{title}</Header>
            <IconMenuButton
              iconVariant="spillover"
              title="Actions"
              options={
                getActionMenuOptions(
                  metricIdentifier,
                  handleCopyEmailToClipboard,
                  incompleteSalesRepMetric
                ) as unknown as DropdownMenuOptions
              }
            />
          </Flex>
          <Text variant={'metadata'}>{subtitle} </Text>
        </Flex>
      </KPICard.Header>
      <KPICard.Content>
        <KPICard.Metric />
      </KPICard.Content>
    </KPICard>
  )
}

export default SalesRepKPICard
